import React from 'react';
import { Container, Row, Col } from '../components/grid';
import {
  Heading1, Heading2, Bold, Paragraph, List, LinkStyled,
} from '../components/typography';
import { Image } from '../components/Image';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="TekniskFustage">
    <Container white mb>
      <Row>
        <Col xs={12} sm={6}>
          <Heading1>Teknisk forklaring om Fustager</Heading1>
          <Heading2>Sådan virker en fustage med fadøl</Heading2>
          <Paragraph>
            Øllet i fustagerne er fuldstændig færdigt, når det fyldes ned i fustagerne. Det vil sige, at den mængde kulsyre der skal være i øllet allerede er tilføjet på forhånd i fustagen. Der er altså nøjagtigt det samme i fustagen, som der er i flasker og dåser.
          </Paragraph>
          <Paragraph>CO<suBold>2</suBold> fra kulsyreflasken blandes altså ikke ind i øllet, men bruges udelukkende til at skubbe øllet ud af fustagen.</Paragraph>
          <Paragraph>Kulsyren presser ned på øllets overflade inde i fustagen. Herved presses øllet op igennem det lange tynde rør, som går fra toppen og næsten ned til bunden af fustagen.</Paragraph>
          <Paragraph>
            Faktisk kunne man bruge mange andre gasser end kulsyre, f.eks. bare komprimeret luft, til at presse øllet ud med.<br />
            Der findes fadølsanlæg med indbyggede trykluftskompresorer, hvilket betyder at man kan undvære kulsyreflasken.
            Hos Skafte kan du leje <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> til din næste fest eller arrangement. De bliver alle leveret med den rette mængde <LinkStyled to="/kulsyre">kulsyre</LinkStyled>, der passer til mængden af de bestilte fustager.
          </Paragraph>
          <Paragraph>
            <Bold>Hvorfor bruger vi kulsyre og ikke bare trykluft?</Bold><br />
            1. Af hygiejniske grunde. Kulsyren er steril, hvorimod trykluft fra en indbygget kompresor i fadølsanlægget suger luft fra selve lokalet hvor festen afholdes.

            Det betyder at holdbarheden på øllet nedsættes væsentligt. Øllet bør derfor drikkes straks efter tilkobling.
          </Paragraph>
          <Paragraph>
            2. Ved brug af kulsyre ved rette tryk, sikrer man øllets oprindelige kulsyreindhold. Det vil sige at det bliver hverken fladt eller får for meget kulsyre. Vores anlæg er indstillet til brug ved alm. stuetemperatur.
          </Paragraph>
          <Paragraph>
            Grunden til at en fadøl har en anden smagsoplevelse end en flaske eller dåse er, at den bliver skænket fra en fadølshane.
            Dette giver mere skum, frigiver kulsyre, så fadøllen får en blødere smag. Desuden spiller den konstante temperatur også en stor rolle. En fadøl er altid ca. 7-8°C.
          </Paragraph>
        </Col>
        <Col xs={12} sm={6} textCenter>
          <Image name="fadoel.fustage-animation.gif" alt="s&aring;dan virker en fustage med fad&oslash;l" />
          <Paragraph fontSize="12px">
            Principtegning af fadølsfustage.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} sm={3} textCenter>
          <Image name="fadoel.fustagefugle.jpg" alt="fustage med Grøn Tuborg" />
        </Col>
        <Col xs={12} sm={9}>
          <Heading2>Facts om en fustage:</Heading2>
          <List>
            <li>Fustager findes i mange størrelser. Vi har dem i 15, 19, 20, 25 og 30 liters.</li>
            <li>De fleste fustager er i rustfrit stål, men der findes også fustager i kunststof.</li>
            <li>Øllet til fustager kommer fra samme tanke som flaskeøllet.</li>
            <li>Fustager fås med de fleste kendte og gode ølmærker i.</li>
            <li>Øllet i fustagerne er drikkeklart. Kulsyren er allerede i Øllet, når det tappes på fustager</li>
            <li>En tom fustage vejer mellem 5,5 og 12 kilo afhængig af størrelse og type.</li>
            <li>I en uåbnet fustage er trykket cirka 3 atm.</li>
            <li>Fustager genbruges mange gange. Nogle fustager er helt tilbage fra 60&apos;erne.</li>
            <li>Fustagerne har, som flasker, mærker der fortæller om øllets tappe-dato og holdbarhed.</li>
            <li>Der findes mange forskellige tilkoblinger. I Danmark er S- og A-kobling det mest almindelige.</li>
            <li>Fustager vaskes, skyldes og fyldes gennem tilkoblingsstudsen (anstikkeren)</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} sm={3} textCenter>
          <Image name="fadoel.fustage-haette.jpg" alt="Fustage Grøn Tuborg med tydelig datomærkning" />
        </Col>
        <Col class="col-xs-12 col-sm-9">
          <Heading2>Plombering af fustager</Heading2>
          <Paragraph>
            Alle fustager leveres med en plastic-støvhætte som samtidig
            fungerer som plombering. Hvis denne hætte er fjernet, skal fadøllet
            betales.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Fordele ved en fustage</Heading2>
        </Col>
        <Col xs={12} md={6}>
          <Paragraph>
            Fustagen er den beholder, hvori fadøllet opbevares.
            Fustager påtappes de samme former for øl som almindelige flasker.
            Til fester er fustagen (i kombination med fadølsanlægget) langt mere praktisk og &quot;brugervenlig&quot; end flasker:
          </Paragraph>
          <Paragraph>
            Også under festen er fustager en fordel. Øllet har hele tiden den rette temperatur.
            Gæsterne synes det er sjovere. De behøver bare at gå op i &quot;baren&quot; og tappe sig selv et glas
            skummende fadøl. Fustagen sørger for (sammen med CO<suBold>2</suBold> beholderen og køleanlægget), at øllet altid er
            friskt og koldt. Noget, der giver stemningen en ekstra tand opad!
          </Paragraph>
        </Col>
        <Col xs={12} md={6} textCenter>
          <Image name="fadoel.fustageprofil.jpg" imageHeight="350px" maxHeight="350px" maxWidth="100%" />
        </Col>
        <Col xs={12} textCenter>
          <Image name="fadoel.fustage-udlobstid.gif" alt="Diagram for udløbstid af fadøl" />
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
